import {
  Box,
  Button,
  Card,
  CardContent,
  CardMedia,
  Grid,
  TextField,
  Typography,
  Input,
  FormControl,
  Select,
  MenuItem,
  SelectChangeEvent,
} from "@mui/material";
import * as Yup from "yup";
import { useFormik } from "formik";
import MainContainer from "../../layout/MainContainer";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import CancelIcon from "@mui/icons-material/Cancel";
import { ChangeEvent, useEffect, useState } from "react";
import {
  useEditCategoryByIdMutation,
  useLazyGetCategoryDetailsQuery,
  usePostCategoryMutation,
} from "../../services/categories";
import { showError, showToast } from "../../constants";
import { UploadMedia } from "../../utils/mediaUpload";
import { isString } from "../../utils/validations";
import { CategoryResponse } from "../../types/General";
import useTranslation from "../../hooks/Translation";

const AddCategories = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [addCategory] = usePostCategoryMutation();
  const [editCategory] = useEditCategoryByIdMutation();
  const [getCategoryDetails] = useLazyGetCategoryDetailsQuery();
  const [category, setCategory] = useState<CategoryResponse>();
  const [selectedCategory, setSelectedCategory] = useState("");
  const translation = useTranslation() as any;
  const [image, setImage] = useState<string>("");
  const [fileName, setFileName] = useState<string>("");

  const getCategoryDetail = async (id: string | undefined) => {
    console.log(id, "gfgfgg");

    try {
      const res = await getCategoryDetails({ id }).unwrap();
      if (res?.statusCode === 200) {
        setCategory(res?.data);
        setImage(res?.data?.image);
        // setSelectedCategory(res?.data?.parent?._id);
      }
    } catch (error: any) {
      console.log(error, "errror");
      showError(error?.data?.message || "");
    }
  };

  const handleImageUpload = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const files = event.target;
    const file = files?.files?.length ? files?.files[0] : "";
    const res = await UploadMedia(file);
    if (res?.statusCode === 200) {
      setImage(res?.data);
    } else {
      showError(res?.message);
    }
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: category?.name || "",
      name_ar: category?.name_ar || "",
    },
    validationSchema: Yup.object({
      name: Yup.string()
        .required(translation.Globals.category_name_req)
        .min(2, translation.Globals.min_2)
        .max(80, translation.Globals.max_80),
      name_ar: Yup.string()
        .required(translation.Globals.category_name_req)
        .min(2, translation.Globals.min_2)
        .max(80, translation.Globals.max_80),
    }),

    onSubmit: async (values) => {
      formik.setSubmitting(true);

      let body = {
        name: values.name,
        image: image,
        appKey: new Date().toISOString(),
        name_ar: values.name_ar,
      };

      if (id) {
        try {
          const response = await editCategory({ body, id }).unwrap();
          if (response?.statusCode === 200) {
            showToast(translation.Globals.category_update);
            navigate("/manage-categories", { replace: true });
          }
        } catch (error: any) {
          showError(error?.data?.message || "");
        }
      } else {
        try {
          const response = await addCategory(body).unwrap();
          if (response?.statusCode === 200) {
            showToast(translation.Globals.category_create);
            navigate("/manage-categories", { replace: true });
          }
        } catch (error: any) {
          showError(error?.data?.message || "");
        }
      }
    },
  });

  useEffect(() => {
    if (id) {
      getCategoryDetail(id);
    }
  }, []);

  return (
    <>
      <MainContainer>
        <div className="main_loyout">
          <div className="dashboard">
            <h1>{id ? translation.Globals.edit_category : translation.Globals.add_category}</h1>
            <Button
              className="btn btn_primary"
              onClick={() => {
                navigate("/manage-categories");
              }}
            >
               {translation.Globals.back}
            </Button>
          </div>
          <Card className="cards">
            <form onSubmit={formik.handleSubmit}>
              <CardContent sx={{ p: 1 }}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Typography className="custom_label">{translation.Globals.image}</Typography>
                    {image ? (
                      <div className="upload_image_preview">
                        <CardMedia component="img" image={image} alt="photo" />
                        <CancelIcon
                          onClick={() => {
                            setImage("");
                            setFileName("");
                          }}
                        />
                      </div>
                    ) : (
                      <Box className="upload_image">
                        <label htmlFor="icon-button-file">
                          <Input
                            sx={{ display: "none" }}
                            id="icon-button-file"
                            type="file"
                            inputProps={{
                              accept: "image/png,image/jpeg",
                            }}
                            onChange={(
                              e: React.ChangeEvent<HTMLInputElement>
                            ) => handleImageUpload(e)}
                          />
                          <Button component="span" className="upload_image_btn">
                            <img
                              src="/static/images/user_placeholder.png"
                              alt=""
                            />
                            <CameraAltIcon />
                          </Button>
                        </label>
                      </Box>
                    )}
                  </Grid>

                  <Grid item lg={4} md={4} sm={6} xs={12}>
                    <Typography className="custom_label">
                    {translation.Globals.category_name_en}<span className="asterisk">*</span>
                    </Typography>
                    <TextField
                      hiddenLabel
                      type={"text"}
                      name="name"
                      className="text_field"
                      variant="outlined"
                      fullWidth
                      placeholder= {translation.Globals.category_name_en}
                      inputProps={{ maxLength: 30 }}
                      onBlur={formik.handleBlur}
                      value={formik.values.name}
                      onChange={(val) => {
                        if (
                          val.target.value === " " ||
                          val.target.value === "."
                        ) {
                        } else if (isString(val.target.value)) {
                          formik.handleChange(val);
                        }
                      }}
                      helperText={formik.touched.name && formik.errors.name}
                    />
                  </Grid>
                  <Grid item lg={4} md={4} sm={6} xs={12}>
                    <Typography className="custom_label">
                    {translation.Globals.category_name_ar}<span className="asterisk">*</span>
                    </Typography>
                    <TextField
                      hiddenLabel
                      type={"text"}
                      name="name_ar"
                      className="text_field"
                      variant="outlined"
                      fullWidth
                      inputProps={{ maxLength: 30 }}
                      placeholder= {translation.Globals.category_name_ar}
                      onBlur={formik.handleBlur}
                      value={formik.values.name_ar}
                      onChange={(val) => {
                        if (
                          val.target.value === " " ||
                          val.target.value === "."
                        ) {
                        } else {
                          formik.handleChange(val);
                        }
                      }}
                      helperText={
                        formik.touched.name_ar && formik.errors.name_ar
                      }
                    />
                  </Grid>
                </Grid>
                <div className="form_btn">
                  <Button
                    size="large"
                    type="submit"
                    className="btn btn_primary"
                  >
                     {translation.Globals.save}
                  </Button>
                </div>
              </CardContent>
            </form>
          </Card>
        </div>
      </MainContainer>
    </>
  );
};

export default AddCategories;
